import { Box } from "@mui/material";
import React from "react";
import logo from "../../Utils/Images/logo192.png";

const Loader = () => {
  return (
    <Box>
      <Box
        sx={{
          width: "60px",
          position: "absolute",
          top: "50%",
          left: " 60%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <img
          style={{
            animation: "rotate 1s linear infinite",
          }}
          width={"100%"}
          height={"100%"}
          src={logo}
          alt="preview"
        />
      </Box>

      <style>
        {`
          @keyframes rotate {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </Box>
  );
};

export default Loader;
